module.exports = __webpack_public_path__ + "img/icon-02.fa57f345.png";